import { TreeItemModel } from './tree-item.model';

export class ReportTreeItemModel extends TreeItemModel {
    hasSchedule: boolean;
    override children: ReportTreeItemModel[] = [];

    constructor(init?: Partial<ReportTreeItemModel>) {
        super();
        Object.assign(this, init);
    }
}
